import {
  AvailableLanguagesEnum,
  BetTypeEnum,
  SpecialBettingsColorEnum,
  SpecialBettingsParityEnum,
} from "../enums/index";

import { IBetApi, IPick } from "../interfaces";

export const isSpecialBetting = (value: string): boolean =>
  value === SpecialBettingsColorEnum.RED ||
  value === SpecialBettingsColorEnum.BLACK ||
  value === SpecialBettingsParityEnum.EVEN ||
  value === SpecialBettingsParityEnum.ODD;

export const getBetObject = (pick: IPick): IBetApi => {
  let betType = BetTypeEnum.NUMBER;
  let betValue = -1;
  if (pick.value === "B" || pick.value === "R") {
    betType = BetTypeEnum.COLOR;
    if (pick.value === "R") {
      betValue = 1;
    } else {
      betValue = 2;
    }
  } else if (pick.value === "ODD" || pick.value === "EVEN") {
    betType = BetTypeEnum.PARITY;
    if (pick.value === "EVEN") {
      betValue = 1;
    } else {
      betValue = 2;
    }
  } else {
    betValue = +pick.value;
  }

  return {
    payIn: pick.valueMultipliers.reduce((a, b) => a + b, 0) * 100,
    betValue,
    betTypeId: betType,
  };
};

export const getBetString = (pick: IBetApi): string => {
  let value = "";
  if (pick.betTypeId === BetTypeEnum.COLOR) {
    if (pick.betValue === 1) {
      value = "R";
    } else {
      value = "B";
    }
  } else if (pick.betTypeId === BetTypeEnum.PARITY) {
    if (pick.betValue === 1) {
      value = "EVEN";
    } else {
      value = "ODD";
    }
  } else {
    value = pick.betValue.toString();
  }
  return value;
};

export const getWindowWidth = (): number =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

// split decimal part and thousands parts from value in cents
// ex.: 999999 -> 9,999.99 ; 10000001 -> 100,000.01
export const formatNumberThousands = (
  value: number,
  isInCents = true
): string =>
  (isInCents ? value / 100 : value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const getCarouselIndexFromNum = (multiplier: number): number => {
  let index = -1;
  switch (multiplier) {
    case 10:
      index = 0;
      break;
    case 20:
      index = 1;
      break;
    case 1000:
      index = 2;
      break;
    case 50:
      index = 3;
      break;
    case 100:
      index = 4;
      break;
    default:
      break;
  }
  return index;
};

export const isIosOrMacOsPlatform = (): boolean => {
  const macOSPlatforms = [
    "Macintosh",
    "MacIntel",
    "MacPPC",
    "Mac68K",
    "darwin",
  ];
  const iOSPlatforms = [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPhone",
    "iPad",
    "iPod",
  ];

  if (
    macOSPlatforms.includes(navigator.platform) ||
    iOSPlatforms.includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  ) {
    return true;
  }

  return false;
};

export const getLocalDate = (
  timeZoneOffset: number,
  hoursOffset: number
): string => {
  const timeZoneOffsetInMiliseconds = timeZoneOffset * 3600000;
  const offsetInMiliseconds = hoursOffset * 3600000;
  const localISOTime = new Date(
    Date.now() + timeZoneOffsetInMiliseconds - offsetInMiliseconds
  )
    .toISOString()
    .split("T")[0];

  return localISOTime;
};

export const getLanguageFromURL = (): {
  languageToSet: string;
  iconToSet: AvailableLanguagesEnum;
} => {
  const urlLanguage = new URLSearchParams(
    window.location.search.toLowerCase()
  ).get("lang");
  let languageToSet = "en";
  let iconToSet = AvailableLanguagesEnum.ENG;

  if (urlLanguage) {
    switch (urlLanguage) {
      case "sr_me":
        languageToSet = "srba";
        iconToSet = AvailableLanguagesEnum.MNE;
        break;
      case "hr":
        languageToSet = "srba";
        iconToSet = AvailableLanguagesEnum.CRO;
        break;
      case "hr_hr":
        languageToSet = "srba";
        iconToSet = AvailableLanguagesEnum.CRO;
        break;
      case "sr_bs":
        languageToSet = "srba";
        iconToSet = AvailableLanguagesEnum.SRBA;
        break;
      case "sr_ba":
        languageToSet = "srba";
        iconToSet = AvailableLanguagesEnum.SRBA;
        break;
      case "bs":
        languageToSet = "srba";
        iconToSet = AvailableLanguagesEnum.SRBA;
        break;
      case "ba":
        languageToSet = "srba";
        iconToSet = AvailableLanguagesEnum.SRBA;
        break;

      case "sr_sr":
        languageToSet = "srsr";
        iconToSet = AvailableLanguagesEnum.SRBA;
        break;
      case "sr_rs":
        languageToSet = "srsr";
        iconToSet = AvailableLanguagesEnum.SRBA;
        break;
      case "sr":
        languageToSet = "srsr";
        iconToSet = AvailableLanguagesEnum.SRSR;
        break;

      default:
        break;
    }
  }

  return { languageToSet, iconToSet };
};
